module.exports = __webpack_public_path__ + "img/human_13.2d00d3f5.png";